export interface NursingInterventionsDetails {
  interval?: string;
  interventionGroup?: string;
  side?: string;
  topography?: string;
}

export enum ChangeType {
  EXECUTION = 3,
  REVERT_ADMINISTRATION = 4,
  REVERT_SUSPENSION = 6,
  SUSPENSION = 5
}